import Base from './Base';
import { HtmlContent } from '@client/utils/html_content';

const InfoCard = ({
  title,
  description = null,
  text,
  className = '',
  icons,
  first = false,
  row = false,
  customComponent = null,
}) => {
  return (
    <Base
      className={
        `${className}` +
        `${row ? 'flex flex-row items-center gap-[48px] flex-wrap md:flex-nowrap' : ''}`
      }
    >
      <div className="flex flex-col gap-1">
        {title && (
          <div className="text-[#5B8C00] font-bold mb-1 text-[16px] w-fit">
            {title}
          </div>
        )}

        {description && <div className="text-[14px]">{description}</div>}
      </div>
      {text && (
        <HtmlContent
          html={text}
          as="div"
          className={'text-black text-[16px]'}
        />
      )}

      {icons && (
        <div className="flex gap-2 mt-2">
          {icons.map((icon, index) => (
            <div
              key={index}
              className="flex items-center justify-center gap-4 w-[48px] h-[48px]"
            >
              <img src={icon.url} alt={icon.alt} className="w-full h-full" />
            </div>
          ))}
        </div>
      )}
      {customComponent && <div className="mt-2">{customComponent}</div>}
    </Base>
  );
};

export default InfoCard;
